// @flow
import React, { PureComponent } from 'react';
import 'app/common/react/components/growth/activation/NuxChecklist/NuxChecklistAction.scss';
import { Box, Icon, Text } from 'gestalt';

export type NuxChecklistActionProps = {|
  name: string,
  icon: string,
  accessibilityLabel: string,
  text: string,
  isCompleted: boolean,
|};

type OwnProps = {|
  ...NuxChecklistActionProps,
  idx: number,
  inCheckAnimationExp: boolean,
|};

type State = {|
  completedCheck: boolean,
|};

class NuxChecklistAction extends PureComponent<OwnProps, State> {
  state = {
    completedCheck: false,
  };

  initiateCheckAnimation() {
    const { isCompleted, idx } = this.props;
    const extraDelay = 500 * idx;
    if (isCompleted) {
      setTimeout(() => {
        window.requestAnimationFrame(() => {
          this.setState({ completedCheck: true });
        });
      }, 500 + extraDelay);
    }
  }

  // Both life cycle methods are needed to update the checklist. On initial load of the HF,
  // the checklist component mounts on the DOM before isCompleted prop gets updated by the UserResource call.
  // This is why the componentDidUpdate method is needed to update the state once the props gets updated.
  // Once a user closeup on Pin and returns to HF the componentDidMount method initiates
  // to check the props to see if isCompleted is true

  componentDidUpdate() {
    this.initiateCheckAnimation();
  }

  componentDidMount() {
    this.initiateCheckAnimation();
  }

  render() {
    const { accessibilityLabel, icon, text, isCompleted, inCheckAnimationExp } = this.props;
    const { completedCheck } = this.state;

    const content = (
      <React.Fragment>
        <Box marginRight={3}>
          {inCheckAnimationExp ? (
            <div className={completedCheck ? 'CheckListIcon__completed' : 'CheckListIcon'}>
              {/* $FlowFixMe: indexer error */}
              <Icon
                size={18}
                icon={completedCheck ? 'check' : icon}
                accessibilityLabel={completedCheck ? 'done' : accessibilityLabel}
                color={completedCheck ? 'white' : 'blue'}
              />
            </div>
          ) : (
            <Box padding={4} color={isCompleted ? 'blue' : 'white'} shape="circle">
              {/* $FlowFixMe: indexer error */}
              <Icon
                size={18}
                icon={isCompleted ? 'check' : icon}
                accessibilityLabel={isCompleted ? 'done' : accessibilityLabel}
                color={isCompleted ? 'white' : 'blue'}
              />
            </Box>
          )}
        </Box>
        <Text size="xl">{text}</Text>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <Box width={265} alignItems="center" lgDisplay="none" mdDisplay="flex" smDisplay="flex">
          {content}
        </Box>
        <Box
          width={265}
          alignItems="center"
          justifyContent="center"
          lgDisplay="flex"
          mdDisplay="none"
          smDisplay="none"
        >
          {content}
        </Box>
      </React.Fragment>
    );
  }
}

export default NuxChecklistAction;
